import { Chip } from "@mui/material";
import { useNavigate } from "react-router-dom";

const CATEGORY_COLORS: Record<string, string> = {
  Politika: "#E63946",
  Promet: "#457B9D",
  Svijet: "#2A9D8F",
  Sport: "#E9C46A",
  Kultura: "#F4A261",
  Znanost: "#6A0572",
  Tehnologija: "#264653",
  Biznis: "#1D3557",
  Zdravlje: "#2ECC71",
  Razno: "#95A5A6",
};

export function CategoryChip({
  name,
  clickable = true,
}: {
  name: string;
  clickable?: boolean;
}) {
  const navigate = useNavigate();
  const color = CATEGORY_COLORS[name] || "#666";

  return (
    <Chip
      label={name}
      size="small"
      onClick={
        clickable
          ? () => navigate(`/kategorija/${name.toLowerCase()}`)
          : undefined
      }
      sx={{
        backgroundColor: color,
        color: "#fff",
        cursor: clickable ? "pointer" : "default",
        "&:hover": clickable
          ? { backgroundColor: color, opacity: 0.85 }
          : undefined,
      }}
    />
  );
}
